import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body pb-1" }
const _hoisted_3 = { class: "form-group row" }
const _hoisted_4 = { class: "col-lg-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "RUC", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Nombre", -1)
const _hoisted_8 = { class: "form-group row" }
const _hoisted_9 = { class: "col-lg-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Siglas", -1)
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Categoría", -1)
const _hoisted_13 = { class: "col-lg-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Ámbito", -1)
const _hoisted_15 = { class: "form-group row" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "País", -1)
const _hoisted_18 = { class: "col-lg-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Región", -1)
const _hoisted_20 = { class: "form-group row" }
const _hoisted_21 = { class: "col-lg-12" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Dirección", -1)
const _hoisted_23 = { class: "form-group row" }
const _hoisted_24 = { class: "col-lg-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Sitio web", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-globe fs-2" }, null, -1)
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = { class: "col-lg-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Télefono 1", -1)
const _hoisted_30 = { class: "col-lg-4" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Télefono 2", -1)
const _hoisted_32 = {
  key: 0,
  class: "col-lg-4"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold" }, "Estado", -1)
const _hoisted_34 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.gblDialog,
    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.gblDialog) = $event)),
    class: "bg-light rounded",
    onOpen: _ctx.onOpen,
    onOpened: _ctx.onOpened,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    top: "2vh"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_34, [
        _createVNode(_component_el_button, {
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.gblDialog = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef))),
          loading: _ctx.loader
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.gblAction == 'new' ? 'Registrar' : 'Actualizar'), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            class: "form form-label-right"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_component_el_form_item, { prop: "ruc" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.ruc,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.ruc) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode(_component_el_form_item, { prop: "business" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.business,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.business) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_el_form_item, { prop: "abrev" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.abrev,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.abrev) = $event)),
                        maxlength: "10"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_el_form_item, { prop: "category" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.category,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.category) = $event)),
                        clearable: "",
                        placeholder: "Seleccionar",
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCategorie, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.iddetails,
                              label: item.name,
                              value: item.iddetails
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_el_form_item, { prop: "instype" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.instype,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.instype) = $event)),
                        clearable: "",
                        placeholder: "Seleccionar"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTypes, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.iddetails,
                              label: item.name,
                              value: item.iddetails
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_el_form_item, { prop: "country" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.country,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.country) = $event)),
                        filterable: "",
                        clearable: "",
                        placeholder: "Seleccione",
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCountry, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `lr-${item.idcountry}`,
                              label: `${item.idcountry} - ${item.name}`,
                              value: item.idcountry
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createVNode(_component_el_form_item, { prop: "idseat" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.idseat,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.idseat) = $event)),
                        filterable: "",
                        clearable: "",
                        placeholder: "Seleccione",
                        class: "w-100"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listRegions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: `lr-${item.idregion}`,
                              label: item.name,
                              value: item.idregion
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_el_form_item, { prop: "address" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.address,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.address) = $event)),
                        type: "textarea"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _hoisted_25,
                  _createVNode(_component_el_form_item, { prop: "siteweb" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.siteweb,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.siteweb) = $event))
                      }, {
                        prepend: _withCtx(() => [
                          _hoisted_26
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createVNode(_component_el_form_item, { prop: "phone1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.phone1,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.phone1) = $event)),
                        maxlength: "9"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_el_form_item, { prop: "phone2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.phone2,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.phone2) = $event)),
                        maxlength: "9"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.form.idinstitution)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                      _hoisted_33,
                      _createVNode(_component_el_form_item, { prop: "mstatus" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.form.mstatus,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.mstatus) = $event)),
                            placeholder: "Seleccione"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listStatus, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: `s-${item.iddetails}`,
                                  label: item.name,
                                  value: item.iddetails
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])), [
            [_directive_loading, _ctx.loader]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onOpened", "onClosed"]))
}